/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockIcon20Regular = forwardRef('TimeClockIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.48 6.443a.75.75 0 0 0-1.5 0v3.123a2 2 0 0 0 1.085 1.78l2.693 1.383a.75.75 0 0 0 .685-1.334l-2.692-1.384a.5.5 0 0 1-.272-.445V6.443Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.001A7.999 7.999 0 1 0 10 18 7.999 7.999 0 0 0 10 2Zm-6.499 8A6.499 6.499 0 1 1 16.5 10 6.499 6.499 0 0 1 3.5 10Z" })));
});
